import { useQuery } from 'react-query';
import AffordableRelationshipService from '../../services/affordableRelationshipService';

export type UseMinorAffordableRelationshipsReturn = {
  minorAffordableRelationships: Array<{ value: ?string, text: string }>,
  isLoading: boolean,
};

export default function useMinorAffordableRelationships(): UseMinorAffordableRelationshipsReturn {
  const queryKey = 'minorAffordableRelationships';
  const affordableRelationshipService = new AffordableRelationshipService();

  // No initialData: it would report the query as loaded before the request
  // returns, and the application form waits on this list before it loads.
  const { data, isLoading } = useQuery(
    queryKey,
    () => {
      return affordableRelationshipService.getAll();
    },
    { refetchOnWindowFocus: false },
  );

  const dataToReturn = !isLoading
    ? (Array.isArray(data) ? data : [])
        .filter(
          (affordableRelationship) => affordableRelationship.childRelationship,
        )
        .map((affordableRelationship) => ({
          value: affordableRelationship.id,
          text: affordableRelationship.name,
        }))
        .sort((a, b) => a.text.localeCompare(b.text))
    : null;

  return {
    minorAffordableRelationships: dataToReturn,
    isLoading,
  };
}
